/**
 * 3D Preview component - Puppet preview canvas
 * Displays real-time 3D puppet preview with React Three Fiber
 */
import { Canvas3DPreview } from './3d/Canvas3DPreview';

export function Preview3D() {
  return (
    <div className="h-full w-full panel-bg">
      <Canvas3DPreview />
    </div>
  );
}
